/* ─── Base ─── */

.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  border: none;
  padding: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background var(--motion-duration-short3)
      var(--motion-easing-standard),
    box-shadow var(--motion-duration-short3) var(--motion-easing-standard),
    opacity var(--motion-duration-short3) var(--motion-easing-standard);
}

/* ─── State layer ─── */

.root::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .root:hover::before {
    opacity: var(--state-hover);
  }
}

.root:focus-visible::before {
  opacity: var(--state-focus);
}

.root:active::before {
  opacity: var(--state-pressed);
}

/* ─── Disabled ─── */

.root:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}

.root:disabled::before {
  display: none;
}

/* ─── Icon sizing ─── */

.root > svg {
  width: 1em;
  height: 1em;
  flex-shrink: 0;
}

/* ─── Sizes ─── */

.sm {
  width: 2.25rem;
  height: 2.25rem;
  font-size: var(--icon-size-xs);
  border-radius: var(--shape-full);
}

.md {
  width: 3rem;
  height: 3rem;
  font-size: var(--icon-size-md);
  border-radius: var(--shape-full);
}

.lg {
  width: 3.5rem;
  height: 3.5rem;
  font-size: var(--icon-size-lg);
  border-radius: var(--shape-full);
}

/* ─── Variants ─── */

.text {
  background: transparent;
  color: var(--md-on-surface-variant);
}

.filled {
  --focus-ring-color: var(--md-on-primary);
  background: var(--md-primary);
  color: var(--md-on-primary);
}

.tonal {
  background: var(--md-primary-container);
  color: var(--md-on-primary-container);
}

.outlined {
  background: transparent;
  color: var(--md-on-surface-variant);
  border: 1px solid var(--md-outline);
}

/* ─── Toggle pressed state ─── */

.text[aria-pressed="true"] {
  color: var(--md-primary);
}

.filled[aria-pressed="true"] {
  background: var(--md-primary);
  color: var(--md-on-primary);
}

.filled[aria-pressed="false"] {
  background: var(--md-surface-container-highest);
  color: var(--md-primary);
}

.tonal[aria-pressed="true"] {
  background: var(--md-primary-container);
  color: var(--md-on-primary-container);
}

.tonal[aria-pressed="false"] {
  background: var(--md-surface-container-highest);
  color: var(--md-on-surface-variant);
}

.outlined[aria-pressed="true"] {
  --focus-ring-color: var(--md-inverse-on-surface);
  background: var(--md-inverse-surface);
  color: var(--md-inverse-on-surface);
  border-color: transparent;
}
